export const BASE_URL = `${process.env.REACT_APP_COLAB_API_URL}/api`;

export const GOOGLE_RECAPTCHA_CLIENT_KEY =
  process.env.REACT_APP_GOOGLE_RECAPTCHA_CLIENT_KEY;

export const USE_RECAPTCHA_ON_LOGIN =
  process.env.REACT_APP_USE_RECAPTCHA_ON_LOGIN === 'true';
